import { get } from 'lodash';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
	TEMerchantsResponsePayload,
	TMonthlyFeeStore,
	TFeeClassResponsePayload,
	TMonthlyFeeResponsePayload,
	TMonthlyFeeListResponsePayload,
	TMonthlyFeeListRequestPayload,
	TAddMonthlyFeeRequestPayload,
	TDeleteMonthlyFeeRequestPayload,
} from './types';
// ==========================================:
export const initialState: TMonthlyFeeStore = {
	eMerchant: null,
	eMerchantLoader: false,
	monthlyFee: null,
	monthlyFeeLoader: false,
	feeClasses: null,
	feeClassesLoader: false,
	monthlyFeeList: null,
	monthlyFeeListLoader: false,
};

// ==========================================:
const monthlyFee = createSlice({
	name: '@@monthlyFee',
	initialState,
	reducers: {
		getEMerchantRequest: (state: TMonthlyFeeStore) => {
			const monthlyFeeState = state;
			monthlyFeeState.eMerchantLoader = true;
		},
		getEMerchantSuccess: (
			state: TMonthlyFeeStore,
			action: PayloadAction<TEMerchantsResponsePayload>,
		) => {
			const { payload } = action;
			const monthlyFeeState = state;
			monthlyFeeState.eMerchant = payload;
			monthlyFeeState.eMerchantLoader = false;
		},
		getMonthlyFeeRequest: (state: TMonthlyFeeStore) => {
			const monthlyFeeState = state;
			monthlyFeeState.monthlyFeeLoader = true;
		},
		getMonthlyFeeSuccess: (
			state: TMonthlyFeeStore,
			action: PayloadAction<TMonthlyFeeResponsePayload>,
		) => {
			const { payload } = action;
			const monthlyFeeState = state;
			monthlyFeeState.monthlyFee = payload;
			monthlyFeeState.monthlyFeeLoader = false;
		},
		getFeeClassesRequest: (state: TMonthlyFeeStore) => {
			const monthlyFeeState = state;
			monthlyFeeState.feeClassesLoader = true;
		},
		getFeeClassesSuccess: (
			state: TMonthlyFeeStore,
			action: PayloadAction<TFeeClassResponsePayload>,
		) => {
			const { payload } = action;
			const monthlyFeeState = state;
			monthlyFeeState.feeClasses = payload;
			monthlyFeeState.feeClassesLoader = false;
		},
		getMonthlyFeeListRequest: (
			state: TMonthlyFeeStore,
			action: PayloadAction<TMonthlyFeeListRequestPayload>,
		) => {
			const monthlyFeeState = state;
			monthlyFeeState.monthlyFeeListLoader = true;
		},
		getMonthlyFeeListSuccess: (
			state: TMonthlyFeeStore,
			action: PayloadAction<TMonthlyFeeListResponsePayload>,
		) => {
			const { payload } = action;
			const monthlyFeeState = state;
			monthlyFeeState.monthlyFeeList = payload;
			monthlyFeeState.monthlyFeeListLoader = false;
		},
		addMonthlyFeeRequest: (
			state: TMonthlyFeeStore,
			action: PayloadAction<TAddMonthlyFeeRequestPayload>,
		) => {},
		deleteMonthlyFeeRequest: (
			state: TMonthlyFeeStore,
			action: PayloadAction<TDeleteMonthlyFeeRequestPayload>,
		) => {},

		assetsInitState: () => initialState,
	},
});

export default monthlyFee.reducer;
export const {
	getEMerchantRequest,
	getEMerchantSuccess,
	getMonthlyFeeRequest,
	getMonthlyFeeSuccess,
	getFeeClassesRequest,
	getFeeClassesSuccess,
	getMonthlyFeeListRequest,
	getMonthlyFeeListSuccess,
	addMonthlyFeeRequest,
	deleteMonthlyFeeRequest,
	assetsInitState,
} = monthlyFee.actions;
